import React from 'react';
import { useLocation } from 'react-router-dom';
import { BreadCrumb } from 'primereact/breadcrumb';
import { MenuItem } from 'primereact/menuitem';

const AppBreadcrumb: React.FC = () => {
    const location = useLocation();

    const getPathnames = () => {
        const pathnames = location.pathname.split('/').filter((x) => x);
        return pathnames;
    };

    const getMenuItems = (): MenuItem[] => {
        const pathnames = getPathnames();
        const items: MenuItem[] = [];

        pathnames.forEach((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const label = name.charAt(0).toUpperCase() + name.slice(1);
            items.push({ label, url: routeTo });
        });

        return items;
    };

    const home: MenuItem = { icon: 'pi pi-home', url: '/' };

    return (
        <div className="layout-breadcrumb-container">
            <BreadCrumb model={getMenuItems()} home={home} />
        </div>
    );
};

export default AppBreadcrumb;